import { LiteProfile } from "@converge-collective/common/models/Profile";
import { imageSize } from "@converge-collective/common/util";
import { Avatar, SxProps } from "@mui/material";

export default function UserAvatar({
  profile,
  sx,
}: {
  profile: LiteProfile;
  sx?: SxProps;
}): React.ReactElement {
  return (
    <Avatar
      sx={sx}
      key={profile.name}
      alt={profile.name}
      src={imageSize(profile.photoURL, 600)}
    >
      <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={profile.photoURL}
      />
    </Avatar>
  );
}
